import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionProcedureState: Dtos.InstitutionProcedure & IRegistrationFormState = {
    id: null,
    institutionId: null,
    institution: null,
    name: null,
    location: null,
    dateOfProcedure: null,
    expiryDate: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IInstitutionProcedureReduxFormState {
    id: IFieldState<number>,
    institutionId: IFieldState<number>,
    institution: IFieldState<Dtos.Institution>,
    name: IFieldState<string>,
    location: IFieldState<string>,
    dateOfProcedure: IFieldState<string>,
    expiryDate: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
}
